export const TargetingMapping = {
    AD_BLOCK_STATUS: 'ab',
    IS_LOGGED_IN: 'l',
}
